import React, { useState } from "react";
import { Input, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { OrdersTable } from "../OrdersTable";
import { ColumnSelector } from "../ColumnSelector";
import SaveNewListButton from "../SavedList/SaveNewListButton";
import { OrderFilters } from "../OrdersFilter";
import { useParams } from "react-router-dom";
import { Routes } from "../../constant/routes";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { ViewType } from "../../constant/general";
import { selectViewType } from "../../store/selector";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ACTIONS from "../../store/action";

const ContainerStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 50px;
  padding-top: 20px;
  transition: all 0.3s ease;
`;

const TableSection = ({
  searchInput,
  setSearchInput,
  patients,
  isSearch,
  onClickTable,
  isFetching,
  onHeaderCell,
  currentPage,
  total,
  fetchOrders,
  isLoadingEnabled
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const { filterListId, savedListViewType } = useParams();
  const isSavedListViewFromExternal = location.pathname.includes(Routes.SAVEDLISTS) ? true : false;
  const viewType = useSelector(selectViewType);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const setFormPopupsAct = (visible) => dispatch(ACTIONS.setFormPopups(visible));

  return (
    <>
      <ContainerStyled>
        {viewType !== ViewType.SavedList.key && !filterListId && (
          <OrderFilters
            filtersVisible={filtersVisible}
            setFiltersVisible={setFiltersVisible}
            isListView={viewType === ViewType.List.key || savedListViewType === ViewType.List.key}
          />
        )}

        <div style={{ width: "100%", overflow: "hidden" }}>
          <Space
            style={{
              width: "100%",
              paddingRight: 50,
              paddingLeft: filtersVisible ? 8 : 115,
              paddingTop: 3,
              justifyContent: isSearch ? "end" : "space-between",
              display: "flex"
            }}
          >
            <div style={{ display: "flex" }}>
              <div id="list_search" style={{ display: "flex" }}>
                <Input
                  allowClear
                  value={searchInput}
                  placeholder={t("search_placeholder")}
                  prefix={<SearchOutlined />}
                  style={{
                    width: 300
                  }}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
              </div>
              {viewType !== ViewType.SavedList.key && !isSavedListViewFromExternal && (
                <SaveNewListButton id="save_list_btn" setFormPopupsAct={setFormPopupsAct} isOwner={false} />
              )}
            </div>
            {patients.length > 0 && <ColumnSelector />}
          </Space>
          <div style={{ flex: "1 1 auto", overflow: "hidden" }}>
            <OrdersTable
              isFetching={isFetching}
              onClickTable={onClickTable}
              patients={patients}
              filtersVisible={filtersVisible}
              setFiltersVisible={setFiltersVisible}
              onHeaderCell={onHeaderCell}
              currentPage={currentPage}
              setSearchInput={setSearchInput}
              searchInput={searchInput}
              total={total}
              fetchOrders={fetchOrders}
              isLoadingEnabled={isLoadingEnabled}
            />
          </div>
        </div>
      </ContainerStyled>
    </>
  );
};

export { TableSection };
